import { useWhatsNewBriefing } from "../../../hooks/useWhatsNewBriefing";

/**
 * Generates the daily briefing in the background, from app root.
 *
 * Renders nothing. It exists because the briefing used to be triggered by the
 * Welcome tab mounting, which meant it only ran if the user happened to land on
 * that tab — deep-linking to a machine, or sitting on Recently Viewed, and it
 * never ran at all. Worse, arriving on the tab meant watching it generate.
 *
 * Mounted here it runs once the session is ready regardless of route, so the card
 * is already built by the time anyone opens it. The once-per-day KV marker still
 * governs whether any work actually happens, and `ensure` is single-flight, so
 * this and the tab's own hook cannot produce two LLM calls between them.
 */
const WhatsNewPrefetcher = () => {
  // The hook itself is a no-op in demo mode; calling it unconditionally keeps
  // hook order stable across a toggle (which reloads anyway).
  useWhatsNewBriefing();
  return null;
};

export default WhatsNewPrefetcher;
